/**
 * @fileoverview This file is generated by the Angular 2 template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties}
 */
/* tslint:disable */
import * as import0 from '../../../../app/tone_list/tone_entry/tone-entry.component';
import * as import1 from '@angular/core/src/change_detection/change_detection_util';
import * as import2 from '@angular/core/src/linker/view';
import * as import3 from '@angular/core/src/linker/view_utils';
import * as import5 from '@angular/core/src/metadata/view';
import * as import6 from '@angular/core/src/linker/view_type';
import * as import7 from '@angular/core/src/change_detection/constants';
import * as import8 from '@angular/core/src/linker/component_factory';
import * as import9 from '../../../../app/app_bus/app-bus';
import * as import10 from './tone-entry.css.shim.ngstyle';
import * as import11 from '../../../../node_modules/@angular/common/src/directives/ng_class.ngfactory';
import * as import12 from '../../../../node_modules/@angular/forms/src/directives/default_value_accessor.ngfactory';
import * as import13 from '../../../../node_modules/@angular/forms/src/directives/ng_model.ngfactory';
import * as import14 from '../../../../node_modules/@angular/forms/src/directives/ng_control_status.ngfactory';
import * as import15 from '../../../../node_modules/@angular/forms/src/directives/range_value_accessor.ngfactory';
import * as import16 from '../../../../app/pipes/time-unit.pipe';
import * as import17 from '@angular/core/src/change_detection/differs/iterable_differs';
import * as import18 from '@angular/core/src/change_detection/differs/keyvalue_differs';
import * as import19 from '@angular/core/src/linker/element_ref';
import * as import20 from '@angular/common/src/directives/ng_class';
import * as import21 from '@angular/forms/src/directives/default_value_accessor';
import * as import22 from '@angular/forms/src/directives/control_value_accessor';
import * as import23 from '@angular/forms/src/directives/ng_model';
import * as import24 from '@angular/forms/src/directives/ng_control';
import * as import25 from '@angular/forms/src/directives/ng_control_status';
import * as import26 from '@angular/forms/src/directives/range_value_accessor';
export class Wrapper_ToneEntryComponent {
    constructor(p0) {
        this._changed = false;
        this.context = new import0.ToneEntryComponent(p0);
        this._expr_0 = import1.UNINITIALIZED;
    }
    ngOnDetach(view, componentView, el) {
    }
    ngOnDestroy() {
    }
    check_entry(currValue, throwOnChange, forceUpdate) {
        if ((forceUpdate || import3.checkBinding(throwOnChange, this._expr_0, currValue))) {
            this._changed = true;
            this.context.entry = currValue;
            this._expr_0 = currValue;
        }
    }
    ngDoCheck(view, el, throwOnChange) {
        var changed = this._changed;
        this._changed = false;
        if (!throwOnChange) {
            if ((view.numberOfChecks === 0)) {
                this.context.ngOnInit();
            }
        }
        return changed;
    }
    checkHost(view, componentView, el, throwOnChange) {
    }
    handleEvent(eventName, $event) {
        var result = true;
        return result;
    }
    subscribe(view, _eventHandler) {
        this._eventHandler = _eventHandler;
    }
}
var renderType_ToneEntryComponent_Host = import3.createRenderComponentType('', 0, import5.ViewEncapsulation.None, [], {});
class View_ToneEntryComponent_Host0 extends import2.AppView {
    constructor(viewUtils, parentView, parentIndex, parentElement) {
        super(View_ToneEntryComponent_Host0, renderType_ToneEntryComponent_Host, import6.ViewType.HOST, viewUtils, parentView, parentIndex, parentElement, import7.ChangeDetectorStatus.CheckAlways);
    }
    createInternal(rootSelector) {
        this._el_0 = import3.selectOrCreateRenderHostElement(this.renderer, 'tone-entry-component', import3.EMPTY_INLINE_ARRAY, rootSelector, null);
        this.compView_0 = new View_ToneEntryComponent0(this.viewUtils, this, 0, this._el_0);
        this._ToneEntryComponent_0_3 = new Wrapper_ToneEntryComponent(this.injectorGet(import9.AppBus, this.parentIndex));
        this.compView_0.create(this._ToneEntryComponent_0_3.context);
        this.init(this._el_0, (this.renderer.directRenderer ? null : [this._el_0]), null);
        return new import8.ComponentRef_(0, this, this._el_0, this._ToneEntryComponent_0_3.context);
    }
    injectorGetInternal(token, requestNodeIndex, notFoundResult) {
        if (((token === import0.ToneEntryComponent) && (0 === requestNodeIndex))) {
            return this._ToneEntryComponent_0_3.context;
        }
        return notFoundResult;
    }
    detectChangesInternal(throwOnChange) {
        this._ToneEntryComponent_0_3.ngDoCheck(this, this._el_0, throwOnChange);
        this.compView_0.internalDetectChanges(throwOnChange);
    }
    destroyInternal() {
        this.compView_0.destroy();
    }
    visitRootNodesInternal(cb, ctx) {
        cb(this._el_0, ctx);
    }
}
export const ToneEntryComponentNgFactory = new import8.ComponentFactory('tone-entry-component', View_ToneEntryComponent_Host0, import0.ToneEntryComponent);
const styles_ToneEntryComponent = [import10.styles];
var renderType_ToneEntryComponent = import3.createRenderComponentType('', 0, import5.ViewEncapsulation.Emulated, styles_ToneEntryComponent, {});
export class View_ToneEntryComponent0 extends import2.AppView {
    constructor(viewUtils, parentView, parentIndex, parentElement) {
        super(View_ToneEntryComponent0, renderType_ToneEntryComponent, import6.ViewType.COMPONENT, viewUtils, parentView, parentIndex, parentElement, import7.ChangeDetectorStatus.CheckAlways);
        this._map_155 = import3.pureProxy1((p0) => {
            return { temp: p0 };
        });
        this._expr_156 = import1.UNINITIALIZED;
        this._map_157 = import3.pureProxy1((p0) => {
            return { error: p0 };
        });
        this._expr_158 = import1.UNINITIALIZED;
        this._expr_159 = import1.UNINITIALIZED;
        this._map_160 = import3.pureProxy1((p0) => {
            return { active: p0 };
        });
        this._map_161 = import3.pureProxy1((p0) => {
            return { active: p0 };
        });
        this._map_162 = import3.pureProxy1((p0) => {
            return { active: p0 };
        });
        this._map_163 = import3.pureProxy1((p0) => {
            return { active: p0 };
        });
        this._map_164 = import3.pureProxy1((p0) => {
            return { error: p0 };
        });
        this._expr_165 = import1.UNINITIALIZED;
        this._expr_166 = import1.UNINITIALIZED;
        this._map_169 = import3.pureProxy1((p0) => {
            return { active: p0 };
        });
        this._expr_170 = import1.UNINITIALIZED;
        this._map_172 = import3.pureProxy1((p0) => {
            return { active: p0 };
        });
        this._expr_173 = import1.UNINITIALIZED;
        this._map_175 = import3.pureProxy1((p0) => {
            return { active: p0 };
        });
        this._expr_176 = import1.UNINITIALIZED;
        this._map_178 = import3.pureProxy1((p0) => {
            return { active: p0 };
        });
        this._expr_179 = import1.UNINITIALIZED;
        this._map_181 = import3.pureProxy1((p0) => {
            return { error: p0 };
        });
        this._expr_182 = import1.UNINITIALIZED;
        this._expr_183 = import1.UNINITIALIZED;
        this._map_185 = import3.pureProxy1((p0) => {
            return { active: p0 };
        });
        this._expr_186 = import1.UNINITIALIZED;
        this._map_188 = import3.pureProxy1((p0) => {
            return { active: p0 };
        });
        this._expr_189 = import1.UNINITIALIZED;
        this._map_191 = import3.pureProxy1((p0) => {
            return { active: p0 };
        });
        this._expr_192 = import1.UNINITIALIZED;
        this._map_194 = import3.pureProxy1((p0) => {
            return { active: p0 };
        });
        this._expr_195 = import1.UNINITIALIZED;
        this._map_197 = import3.pureProxy1((p0) => {
            return { disabled: p0 };
        });
        this._map_198 = import3.pureProxy1((p0) => {
            return { disabled: p0 };
        });
    }
    createInternal(rootSelector) {
        const parentRenderNode = this.renderer.createViewRoot(this.parentElement);
        this._text_0 = this.renderer.createText(parentRenderNode, '\n', null);
        this._el_1 = import3.createRenderElement(this.renderer, parentRenderNode, 'div', new import3.InlineArray2(2, 'class', 'tone-entry tone-entry-row'), null);
        this._NgClass_1_3 = new import11.Wrapper_NgClass(this.parentView.injectorGet(import17.IterableDiffers, this.parentIndex), this.parentView.injectorGet(import18.KeyValueDiffers, this.parentIndex), new import19.ElementRef(this._el_1), this.renderer);
        this._text_2 = this.renderer.createText(this._el_1, '\n  ', null);
        this._el_3 = import3.createRenderElement(this.renderer, this._el_1, 'div', new import3.InlineArray2(2, 'class', 'delete-ctnr'), null);
        this._text_4 = this.renderer.createText(this._el_3, '\n    ', null);
        this._el_5 = import3.createRenderElement(this.renderer, this._el_3, 'div', new import3.InlineArray2(2, 'class', 'fa fa-minus-circle'), null);
        this._text_6 = this.renderer.createText(this._el_3, '\n  ', null);
        this._text_7 = this.renderer.createText(this._el_1, '\n  ', null);
        this._el_8 = import3.createRenderElement(this.renderer, this._el_1, 'div', new import3.InlineArray2(2, 'class', 'frequency-ctnr'), null);
        this._text_9 = this.renderer.createText(this._el_8, '\n    ', null);
        this._el_10 = import3.createRenderElement(this.renderer, this._el_8, 'div', new import3.InlineArray2(2, 'class', 'input-group'), null);
        this._text_11 = this.renderer.createText(this._el_10, '\n      ', null);
        this._el_12 = import3.createRenderElement(this.renderer, this._el_10, 'input', new import3.InlineArray8(6, 'class', 'form-control', 'placeholder', 'Hz', 'type', 'text'), null);
        this._NgClass_12_3 = new import11.Wrapper_NgClass(this.parentView.injectorGet(import17.IterableDiffers, this.parentIndex), this.parentView.injectorGet(import18.KeyValueDiffers, this.parentIndex), new import19.ElementRef(this._el_12), this.renderer);
        this._DefaultValueAccessor_12_4 = new import12.Wrapper_DefaultValueAccessor(this.renderer, new import19.ElementRef(this._el_12));
        this._NG_VALUE_ACCESSOR_12_5 = [this._DefaultValueAccessor_12_4.context];
        this._NgModel_12_6 = new import13.Wrapper_NgModel(null, null, null, this._NG_VALUE_ACCESSOR_12_5);
        this._NgControl_12_7 = this._NgModel_12_6.context;
        this._NgControlStatus_12_8 = new import14.Wrapper_NgControlStatus(this._NgControl_12_7);
        this._text_13 = this.renderer.createText(this._el_10, '\n      ', null);
        this._el_14 = import3.createRenderElement(this.renderer, this._el_10, 'div', new import3.InlineArray2(2, 'class', 'input-group-btn'), null);
        this._text_15 = this.renderer.createText(this._el_14, '\n        ', null);
        this._el_16 = import3.createRenderElement(this.renderer, this._el_14, 'button', new import3.InlineArray16(10, 'aria-expanded', 'false', 'aria-haspopup', 'true', 'class', 'btn btn-primary dropdown-toggle', 'data-toggle', 'dropdown', 'type', 'button'), null);
        this._text_17 = this.renderer.createText(this._el_16, '', null);
        this._text_18 = this.renderer.createText(this._el_14, '\n        ', null);
        this._el_19 = import3.createRenderElement(this.renderer, this._el_14, 'div', new import3.InlineArray2(2, 'class', 'dropdown-menu'), null);
        this._el_20 = import3.createRenderElement(this.renderer, this._el_19, 'span', new import3.InlineArray2(2, 'class', 'dropdown-item'), null);
        this._NgClass_20_3 = new import11.Wrapper_NgClass(this.parentView.injectorGet(import17.IterableDiffers, this.parentIndex), this.parentView.injectorGet(import18.KeyValueDiffers, this.parentIndex), new import19.ElementRef(this._el_20), this.renderer);
        this._text_21 = this.renderer.createText(this._el_20, 'sine', null);
        this._el_22 = import3.createRenderElement(this.renderer, this._el_19, 'span', new import3.InlineArray2(2, 'class', 'dropdown-item'), null);
        this._NgClass_22_3 = new import11.Wrapper_NgClass(this.parentView.injectorGet(import17.IterableDiffers, this.parentIndex), this.parentView.injectorGet(import18.KeyValueDiffers, this.parentIndex), new import19.ElementRef(this._el_22), this.renderer);
        this._text_23 = this.renderer.createText(this._el_22, 'square', null);
        this._el_24 = import3.createRenderElement(this.renderer, this._el_19, 'span', new import3.InlineArray2(2, 'class', 'dropdown-item'), null);
        this._NgClass_24_3 = new import11.Wrapper_NgClass(this.parentView.injectorGet(import17.IterableDiffers, this.parentIndex), this.parentView.injectorGet(import18.KeyValueDiffers, this.parentIndex), new import19.ElementRef(this._el_24), this.renderer);
        this._text_25 = this.renderer.createText(this._el_24, 'triangle', null);
        this._el_26 = import3.createRenderElement(this.renderer, this._el_19, 'span', new import3.InlineArray2(2, 'class', 'dropdown-item'), null);
        this._NgClass_26_3 = new import11.Wrapper_NgClass(this.parentView.injectorGet(import17.IterableDiffers, this.parentIndex), this.parentView.injectorGet(import18.KeyValueDiffers, this.parentIndex), new import19.ElementRef(this._el_26), this.renderer);
        this._text_27 = this.renderer.createText(this._el_26, 'sawtooth', null);
        this._text_28 = this.renderer.createText(this._el_14, '\n      ', null);
        this._text_29 = this.renderer.createText(this._el_10, '\n    ', null);
        this._text_30 = this.renderer.createText(this._el_8, '\n  ', null);
        this._text_31 = this.renderer.createText(this._el_1, '\n  ', null);
        this._el_32 = import3.createRenderElement(this.renderer, this._el_1, 'div', new import3.InlineArray2(2, 'class', 'delay-ctnr'), null);
        this._text_33 = this.renderer.createText(this._el_32, '\n    ', null);
        this._el_34 = import3.createRenderElement(this.renderer, this._el_32, 'div', new import3.InlineArray2(2, 'class', 'input-group'), null);
        this._text_35 = this.renderer.createText(this._el_34, '\n      ', null);
        this._el_36 = import3.createRenderElement(this.renderer, this._el_34, 'input', new import3.InlineArray8(6, 'class', 'form-control', 'placeholder', '0', 'type', 'text'), null);
        this._NgClass_36_3 = new import11.Wrapper_NgClass(this.parentView.injectorGet(import17.IterableDiffers, this.parentIndex), this.parentView.injectorGet(import18.KeyValueDiffers, this.parentIndex), new import19.ElementRef(this._el_36), this.renderer);
        this._DefaultValueAccessor_36_4 = new import12.Wrapper_DefaultValueAccessor(this.renderer, new import19.ElementRef(this._el_36));
        this._NG_VALUE_ACCESSOR_36_5 = [this._DefaultValueAccessor_36_4.context];
        this._NgModel_36_6 = new import13.Wrapper_NgModel(null, null, null, this._NG_VALUE_ACCESSOR_36_5);
        this._NgControl_36_7 = this._NgModel_36_6.context;
        this._NgControlStatus_36_8 = new import14.Wrapper_NgControlStatus(this._NgControl_36_7);
        this._text_37 = this.renderer.createText(this._el_34, '\n      ', null);
        this._el_38 = import3.createRenderElement(this.renderer, this._el_34, 'div', new import3.InlineArray2(2, 'class', 'input-group-btn'), null);
        this._text_39 = this.renderer.createText(this._el_38, '\n        ', null);
        this._el_40 = import3.createRenderElement(this.renderer, this._el_38, 'button', new import3.InlineArray16(10, 'aria-expanded', 'false', 'aria-haspopup', 'true', 'class', 'btn btn-primary dropdown-toggle', 'data-toggle', 'dropdown', 'type', 'button'), null);
        this._text_41 = this.renderer.createText(this._el_40, '', null);
        this._text_42 = this.renderer.createText(this._el_38, '\n        ', null);
        this._el_43 = import3.createRenderElement(this.renderer, this._el_38, 'div', new import3.InlineArray2(2, 'class', 'dropdown-menu'), null);
        this._el_44 = import3.createRenderElement(this.renderer, this._el_43, 'span', new import3.InlineArray2(2, 'class', 'dropdown-item'), null);
        this._NgClass_44_3 = new import11.Wrapper_NgClass(this.parentView.injectorGet(import17.IterableDiffers, this.parentIndex), this.parentView.injectorGet(import18.KeyValueDiffers, this.parentIndex), new import19.ElementRef(this._el_44), this.renderer);
        this._text_45 = this.renderer.createText(this._el_44, '', null);
        this._el_46 = import3.createRenderElement(this.renderer, this._el_43, 'span', new import3.InlineArray2(2, 'class', 'dropdown-item'), null);
        this._NgClass_46_3 = new import11.Wrapper_NgClass(this.parentView.injectorGet(import17.IterableDiffers, this.parentIndex), this.parentView.injectorGet(import18.KeyValueDiffers, this.parentIndex), new import19.ElementRef(this._el_46), this.renderer);
        this._text_47 = this.renderer.createText(this._el_46, '', null);
        this._el_48 = import3.createRenderElement(this.renderer, this._el_43, 'span', new import3.InlineArray2(2, 'class', 'dropdown-item'), null);
        this._NgClass_48_3 = new import11.Wrapper_NgClass(this.parentView.injectorGet(import17.IterableDiffers, this.parentIndex), this.parentView.injectorGet(import18.KeyValueDiffers, this.parentIndex), new import19.ElementRef(this._el_48), this.renderer);
        this._text_49 = this.renderer.createText(this._el_48, '', null);
        this._el_50 = import3.createRenderElement(this.renderer, this._el_43, 'span', new import3.InlineArray2(2, 'class', 'dropdown-item'), null);
        this._NgClass_50_3 = new import11.Wrapper_NgClass(this.parentView.injectorGet(import17.IterableDiffers, this.parentIndex), this.parentView.injectorGet(import18.KeyValueDiffers, this.parentIndex), new import19.ElementRef(this._el_50), this.renderer);
        this._text_51 = this.renderer.createText(this._el_50, '', null);
        this._text_52 = this.renderer.createText(this._el_38, '\n      ', null);
        this._text_53 = this.renderer.createText(this._el_34, '\n    ', null);
        this._text_54 = this.renderer.createText(this._el_32, '\n  ', null);
        this._text_55 = this.renderer.createText(this._el_1, '\n  ', null);
        this._el_56 = import3.createRenderElement(this.renderer, this._el_1, 'div', new import3.InlineArray2(2, 'class', 'duration-ctnr'), null);
        this._text_57 = this.renderer.createText(this._el_56, '\n    ', null);
        this._el_58 = import3.createRenderElement(this.renderer, this._el_56, 'div', new import3.InlineArray2(2, 'class', 'input-group'), null);
        this._text_59 = this.renderer.createText(this._el_58, '\n      ', null);
        this._el_60 = import3.createRenderElement(this.renderer, this._el_58, 'input', new import3.InlineArray8(6, 'class', 'form-control', 'placeholder', '0', 'type', 'text'), null);
        this._NgClass_60_3 = new import11.Wrapper_NgClass(this.parentView.injectorGet(import17.IterableDiffers, this.parentIndex), this.parentView.injectorGet(import18.KeyValueDiffers, this.parentIndex), new import19.ElementRef(this._el_60), this.renderer);
        this._DefaultValueAccessor_60_4 = new import12.Wrapper_DefaultValueAccessor(this.renderer, new import19.ElementRef(this._el_60));
        this._NG_VALUE_ACCESSOR_60_5 = [this._DefaultValueAccessor_60_4.context];
        this._NgModel_60_6 = new import13.Wrapper_NgModel(null, null, null, this._NG_VALUE_ACCESSOR_60_5);
        this._NgControl_60_7 = this._NgModel_60_6.context;
        this._NgControlStatus_60_8 = new import14.Wrapper_NgControlStatus(this._NgControl_60_7);
        this._text_61 = this.renderer.createText(this._el_58, '\n      ', null);
        this._el_62 = import3.createRenderElement(this.renderer, this._el_58, 'div', new import3.InlineArray2(2, 'class', 'input-group-btn'), null);
        this._text_63 = this.renderer.createText(this._el_62, '\n        ', null);
        this._el_64 = import3.createRenderElement(this.renderer, this._el_62, 'button', new import3.InlineArray16(10, 'aria-expanded', 'false', 'aria-haspopup', 'true', 'class', 'btn btn-primary dropdown-toggle', 'data-toggle', 'dropdown', 'type', 'button'), null);
        this._text_65 = this.renderer.createText(this._el_64, '', null);
        this._text_66 = this.renderer.createText(this._el_62, '\n        ', null);
        this._el_67 = import3.createRenderElement(this.renderer, this._el_62, 'div', new import3.InlineArray2(2, 'class', 'dropdown-menu'), null);
        this._el_68 = import3.createRenderElement(this.renderer, this._el_67, 'span', new import3.InlineArray2(2, 'class', 'dropdown-item'), null);
        this._NgClass_68_3 = new import11.Wrapper_NgClass(this.parentView.injectorGet(import17.IterableDiffers, this.parentIndex), this.parentView.injectorGet(import18.KeyValueDiffers, this.parentIndex), new import19.ElementRef(this._el_68), this.renderer);
        this._text_69 = this.renderer.createText(this._el_68, '', null);
        this._el_70 = import3.createRenderElement(this.renderer, this._el_67, 'span', new import3.InlineArray2(2, 'class', 'dropdown-item'), null);
        this._NgClass_70_3 = new import11.Wrapper_NgClass(this.parentView.injectorGet(import17.IterableDiffers, this.parentIndex), this.parentView.injectorGet(import18.KeyValueDiffers, this.parentIndex), new import19.ElementRef(this._el_70), this.renderer);
        this._text_71 = this.renderer.createText(this._el_70, '', null);
        this._el_72 = import3.createRenderElement(this.renderer, this._el_67, 'span', new import3.InlineArray2(2, 'class', 'dropdown-item'), null);
        this._NgClass_72_3 = new import11.Wrapper_NgClass(this.parentView.injectorGet(import17.IterableDiffers, this.parentIndex), this.parentView.injectorGet(import18.KeyValueDiffers, this.parentIndex), new import19.ElementRef(this._el_72), this.renderer);
        this._text_73 = this.renderer.createText(this._el_72, '', null);
        this._el_74 = import3.createRenderElement(this.renderer, this._el_67, 'span', new import3.InlineArray2(2, 'class', 'dropdown-item'), null);
        this._NgClass_74_3 = new import11.Wrapper_NgClass(this.parentView.injectorGet(import17.IterableDiffers, this.parentIndex), this.parentView.injectorGet(import18.KeyValueDiffers, this.parentIndex), new import19.ElementRef(this._el_74), this.renderer);
        this._text_75 = this.renderer.createText(this._el_74, '', null);
        this._text_76 = this.renderer.createText(this._el_62, '\n      ', null);
        this._text_77 = this.renderer.createText(this._el_58, '\n    ', null);
        this._text_78 = this.renderer.createText(this._el_56, '\n  ', null);
        this._text_79 = this.renderer.createText(this._el_1, '\n  ', null);
        this._el_80 = import3.createRenderElement(this.renderer, this._el_1, 'div', new import3.InlineArray2(2, 'class', 'volume-ctnr'), null);
        this._text_81 = this.renderer.createText(this._el_80, '\n    ', null);
        this._el_82 = import3.createRenderElement(this.renderer, this._el_80, 'div', new import3.InlineArray2(2, 'class', 'input-group'), null);
        this._text_83 = this.renderer.createText(this._el_82, '\n      ', null);
        this._el_84 = import3.createRenderElement(this.renderer, this._el_82, 'input', new import3.InlineArray8(6, 'class', 'form-control', 'placeholder', '0', 'type', 'text'), null);
        this._DefaultValueAccessor_84_3 = new import12.Wrapper_DefaultValueAccessor(this.renderer, new import19.ElementRef(this._el_84));
        this._NG_VALUE_ACCESSOR_84_4 = [this._DefaultValueAccessor_84_3.context];
        this._NgModel_84_5 = new import13.Wrapper_NgModel(null, null, null, this._NG_VALUE_ACCESSOR_84_4);
        this._NgControl_84_6 = this._NgModel_84_5.context;
        this._NgControlStatus_84_7 = new import14.Wrapper_NgControlStatus(this._NgControl_84_6);
        this._el_85 = import3.createRenderElement(this.renderer, this._el_82, 'span', new import3.InlineArray2(2, 'class', 'input-group-addon'), null);
        this._text_86 = this.renderer.createText(this._el_85, '%', null);
        this._text_87 = this.renderer.createText(this._el_82, '\n    ', null);
        this._text_88 = this.renderer.createText(this._el_80, '\n  ', null);
        this._text_89 = this.renderer.createText(this._el_1, '\n  ', null);
        this._el_90 = import3.createRenderElement(this.renderer, this._el_1, 'div', new import3.InlineArray2(2, 'class', 'pan-ctnr'), null);
        this._text_91 = this.renderer.createText(this._el_90, '\n    ', null);
        this._el_92 = import3.createRenderElement(this.renderer, this._el_90, 'div', new import3.InlineArray2(2, 'class', 'range-ctnr'), null);
        this._text_93 = this.renderer.createText(this._el_92, '\n      ', null);
        this._el_94 = import3.createRenderElement(this.renderer, this._el_92, 'p', new import3.InlineArray2(2, 'class', 'left-desc'), null);
        this._NgClass_94_3 = new import11.Wrapper_NgClass(this.parentView.injectorGet(import17.IterableDiffers, this.parentIndex), this.parentView.injectorGet(import18.KeyValueDiffers, this.parentIndex), new import19.ElementRef(this._el_94), this.renderer);
        this._text_95 = this.renderer.createText(this._el_94, 'L', null);
        this._text_96 = this.renderer.createText(this._el_92, '\n      ', null);
        this._el_97 = import3.createRenderElement(this.renderer, this._el_92, 'p', new import3.InlineArray2(2, 'class', 'right-desc'), null);
        this._NgClass_97_3 = new import11.Wrapper_NgClass(this.parentView.injectorGet(import17.IterableDiffers, this.parentIndex), this.parentView.injectorGet(import18.KeyValueDiffers, this.parentIndex), new import19.ElementRef(this._el_97), this.renderer);
        this._text_98 = this.renderer.createText(this._el_97, 'R', null);
        this._text_99 = this.renderer.createText(this._el_92, '\n      ', null);
        this._el_100 = import3.createRenderElement(this.renderer, this._el_92, 'input', new import3.InlineArray16(10, 'class', 'form-control range-input', 'max', '1', 'min', '-1', 'step', '0.01', 'type', 'range'), null);
        this._DefaultValueAccessor_100_3 = new import12.Wrapper_DefaultValueAccessor(this.renderer, new import19.ElementRef(this._el_100));
        this._RangeValueAccessor_100_4 = new import15.Wrapper_RangeValueAccessor(this.renderer, new import19.ElementRef(this._el_100));
        this._NG_VALUE_ACCESSOR_100_5 = [
            this._DefaultValueAccessor_100_3.context,
            this._RangeValueAccessor_100_4.context
        ];
        this._NgModel_100_6 = new import13.Wrapper_NgModel(null, null, null, this._NG_VALUE_ACCESSOR_100_5);
        this._NgControl_100_7 = this._NgModel_100_6.context;
        this._NgControlStatus_100_8 = new import14.Wrapper_NgControlStatus(this._NgControl_100_7);
        this._text_101 = this.renderer.createText(this._el_92, '\n    ', null);
        this._text_102 = this.renderer.createText(this._el_90, '\n    ', null);
        this._el_103 = import3.createRenderElement(this.renderer, this._el_90, 'input', new import3.InlineArray4(4, 'class', 'form-control text-input', 'type', 'text'), null);
        this._DefaultValueAccessor_103_3 = new import12.Wrapper_DefaultValueAccessor(this.renderer, new import19.ElementRef(this._el_103));
        this._NG_VALUE_ACCESSOR_103_4 = [this._DefaultValueAccessor_103_3.context];
        this._NgModel_103_5 = new import13.Wrapper_NgModel(null, null, null, this._NG_VALUE_ACCESSOR_103_4);
        this._NgControl_103_6 = this._NgModel_103_5.context;
        this._NgControlStatus_103_7 = new import14.Wrapper_NgControlStatus(this._NgControl_103_6);
        this._text_104 = this.renderer.createText(this._el_90, '\n  ', null);
        this._text_105 = this.renderer.createText(this._el_1, '\n', null);
        var disposable_0 = import3.subscribeToRenderElement(this, this._el_5, new import3.InlineArray2(2, 'click', null), this.eventHandler(this.handleEvent_5));
        var disposable_1 = import3.subscribeToRenderElement(this, this._el_12, new import3.InlineArray8(6, 'ngModelChange', null, 'input', null, 'blur', null), this.eventHandler(this.handleEvent_12));
        this._NgModel_12_6.subscribe(this, this.eventHandler(this.handleEvent_12), true);
        var disposable_2 = import3.subscribeToRenderElement(this, this._el_20, new import3.InlineArray2(2, 'click', null), this.eventHandler(this.handleEvent_20));
        var disposable_3 = import3.subscribeToRenderElement(this, this._el_22, new import3.InlineArray2(2, 'click', null), this.eventHandler(this.handleEvent_22));
        var disposable_4 = import3.subscribeToRenderElement(this, this._el_24, new import3.InlineArray2(2, 'click', null), this.eventHandler(this.handleEvent_24));
        var disposable_5 = import3.subscribeToRenderElement(this, this._el_26, new import3.InlineArray2(2, 'click', null), this.eventHandler(this.handleEvent_26));
        var disposable_6 = import3.subscribeToRenderElement(this, this._el_36, new import3.InlineArray8(6, 'ngModelChange', null, 'input', null, 'blur', null), this.eventHandler(this.handleEvent_36));
        this._NgModel_36_6.subscribe(this, this.eventHandler(this.handleEvent_36), true);
        this._pipe_timeunit_0 = new import16.TimeUnitPipe();
        this._pipe_timeunit_0_0 = import3.pureProxy2(this._pipe_timeunit_0.transform.bind(this._pipe_timeunit_0));
        var disposable_7 = import3.subscribeToRenderElement(this, this._el_44, new import3.InlineArray2(2, 'click', null), this.eventHandler(this.handleEvent_44));
        this._pipe_timeunit_0_1 = import3.pureProxy2(this._pipe_timeunit_0.transform.bind(this._pipe_timeunit_0));
        var disposable_8 = import3.subscribeToRenderElement(this, this._el_46, new import3.InlineArray2(2, 'click', null), this.eventHandler(this.handleEvent_46));
        this._pipe_timeunit_0_2 = import3.pureProxy2(this._pipe_timeunit_0.transform.bind(this._pipe_timeunit_0));
        var disposable_9 = import3.subscribeToRenderElement(this, this._el_48, new import3.InlineArray2(2, 'click', null), this.eventHandler(this.handleEvent_48));
        this._pipe_timeunit_0_3 = import3.pureProxy2(this._pipe_timeunit_0.transform.bind(this._pipe_timeunit_0));
        var disposable_10 = import3.subscribeToRenderElement(this, this._el_50, new import3.InlineArray2(2, 'click', null), this.eventHandler(this.handleEvent_50));
        this._pipe_timeunit_0_4 = import3.pureProxy2(this._pipe_timeunit_0.transform.bind(this._pipe_timeunit_0));
        var disposable_11 = import3.subscribeToRenderElement(this, this._el_60, new import3.InlineArray8(6, 'ngModelChange', null, 'input', null, 'blur', null), this.eventHandler(this.handleEvent_60));
        this._NgModel_60_6.subscribe(this, this.eventHandler(this.handleEvent_60), true);
        this._pipe_timeunit_0_5 = import3.pureProxy2(this._pipe_timeunit_0.transform.bind(this._pipe_timeunit_0));
        var disposable_12 = import3.subscribeToRenderElement(this, this._el_68, new import3.InlineArray2(2, 'click', null), this.eventHandler(this.handleEvent_68));
        this._pipe_timeunit_0_6 = import3.pureProxy2(this._pipe_timeunit_0.transform.bind(this._pipe_timeunit_0));
        var disposable_13 = import3.subscribeToRenderElement(this, this._el_70, new import3.InlineArray2(2, 'click', null), this.eventHandler(this.handleEvent_70));
        this._pipe_timeunit_0_7 = import3.pureProxy2(this._pipe_timeunit_0.transform.bind(this._pipe_timeunit_0));
        var disposable_14 = import3.subscribeToRenderElement(this, this._el_72, new import3.InlineArray2(2, 'click', null), this.eventHandler(this.handleEvent_72));
        this._pipe_timeunit_0_8 = import3.pureProxy2(this._pipe_timeunit_0.transform.bind(this._pipe_timeunit_0));
        var disposable_15 = import3.subscribeToRenderElement(this, this._el_74, new import3.InlineArray2(2, 'click', null), this.eventHandler(this.handleEvent_74));
        this._pipe_timeunit_0_9 = import3.pureProxy2(this._pipe_timeunit_0.transform.bind(this._pipe_timeunit_0));
        var disposable_16 = import3.subscribeToRenderElement(this, this._el_84, new import3.InlineArray8(8, 'ngModelChange', null, 'change', null, 'input', null, 'blur', null), this.eventHandler(this.handleEvent_84));
        this._NgModel_84_5.subscribe(this, this.eventHandler(this.handleEvent_84), true);
        var disposable_17 = import3.subscribeToRenderElement(this, this._el_100, new import3.InlineArray8(8, 'ngModelChange', null, 'input', null, 'blur', null, 'change', null), this.eventHandler(this.handleEvent_100));
        this._NgModel_100_6.subscribe(this, this.eventHandler(this.handleEvent_100), true);
        var disposable_18 = import3.subscribeToRenderElement(this, this._el_103, new import3.InlineArray8(8, 'ngModelChange', null, 'change', null, 'input', null, 'blur', null), this.eventHandler(this.handleEvent_103));
        this._NgModel_103_5.subscribe(this, this.eventHandler(this.handleEvent_103), true);
        this.init(null, (this.renderer.directRenderer ? null : [
            this._text_0,
            this._el_1,
            this._text_2,
            this._el_3,
            this._text_4,
            this._el_5,
            this._text_6,
            this._text_7,
            this._el_8,
            this._text_9,
            this._el_10,
            this._text_11,
            this._el_12,
            this._text_13,
            this._el_14,
            this._text_15,
            this._el_16,
            this._text_17,
            this._text_18,
            this._el_19,
            this._el_20,
            this._text_21,
            this._el_22,
            this._text_23,
            this._el_24,
            this._text_25,
            this._el_26,
            this._text_27,
            this._text_28,
            this._text_29,
            this._text_30,
            this._text_31,
            this._el_32,
            this._text_33,
            this._el_34,
            this._text_35,
            this._el_36,
            this._text_37,
            this._el_38,
            this._text_39,
            this._el_40,
            this._text_41,
            this._text_42,
            this._el_43,
            this._el_44,
            this._text_45,
            this._el_46,
            this._text_47,
            this._el_48,
            this._text_49,
            this._el_50,
            this._text_51,
            this._text_52,
            this._text_53,
            this._text_54,
            this._text_55,
            this._el_56,
            this._text_57,
            this._el_58,
            this._text_59,
            this._el_60,
            this._text_61,
            this._el_62,
            this._text_63,
            this._el_64,
            this._text_65,
            this._text_66,
            this._el_67,
            this._el_68,
            this._text_69,
            this._el_70,
            this._text_71,
            this._el_72,
            this._text_73,
            this._el_74,
            this._text_75,
            this._text_76,
            this._text_77,
            this._text_78,
            this._text_79,
            this._el_80,
            this._text_81,
            this._el_82,
            this._text_83,
            this._el_84,
            this._el_85,
            this._text_86,
            this._text_87,
            this._text_88,
            this._text_89,
            this._el_90,
            this._text_91,
            this._el_92,
            this._text_93,
            this._el_94,
            this._text_95,
            this._text_96,
            this._el_97,
            this._text_98,
            this._text_99,
            this._el_100,
            this._text_101,
            this._text_102,
            this._el_103,
            this._text_104,
            this._text_105
        ]), [
            disposable_0,
            disposable_1,
            disposable_2,
            disposable_3,
            disposable_4,
            disposable_5,
            disposable_6,
            disposable_7,
            disposable_8,
            disposable_9,
            disposable_10,
            disposable_11,
            disposable_12,
            disposable_13,
            disposable_14,
            disposable_15,
            disposable_16,
            disposable_17,
            disposable_18
        ]);
        return null;
    }
    injectorGetInternal(token, requestNodeIndex, notFoundResult) {
        if (((token === import20.NgClass) && (12 === requestNodeIndex))) {
            return this._NgClass_12_3.context;
        }
        if (((token === import21.DefaultValueAccessor) && (12 === requestNodeIndex))) {
            return this._DefaultValueAccessor_12_4.context;
        }
        if (((token === import22.NG_VALUE_ACCESSOR) && (12 === requestNodeIndex))) {
            return this._NG_VALUE_ACCESSOR_12_5;
        }
        if (((token === import23.NgModel) && (12 === requestNodeIndex))) {
            return this._NgModel_12_6.context;
        }
        if (((token === import24.NgControl) && (12 === requestNodeIndex))) {
            return this._NgControl_12_7;
        }
        if (((token === import25.NgControlStatus) && (12 === requestNodeIndex))) {
            return this._NgControlStatus_12_8.context;
        }
        if (((token === import20.NgClass) && ((20 <= requestNodeIndex) && (requestNodeIndex <= 21)))) {
            return this._NgClass_20_3.context;
        }
        if (((token === import20.NgClass) && ((22 <= requestNodeIndex) && (requestNodeIndex <= 23)))) {
            return this._NgClass_22_3.context;
        }
        if (((token === import20.NgClass) && ((24 <= requestNodeIndex) && (requestNodeIndex <= 25)))) {
            return this._NgClass_24_3.context;
        }
        if (((token === import20.NgClass) && ((26 <= requestNodeIndex) && (requestNodeIndex <= 27)))) {
            return this._NgClass_26_3.context;
        }
        if (((token === import20.NgClass) && (36 === requestNodeIndex))) {
            return this._NgClass_36_3.context;
        }
        if (((token === import21.DefaultValueAccessor) && (36 === requestNodeIndex))) {
            return this._DefaultValueAccessor_36_4.context;
        }
        if (((token === import22.NG_VALUE_ACCESSOR) && (36 === requestNodeIndex))) {
            return this._NG_VALUE_ACCESSOR_36_5;
        }
        if (((token === import23.NgModel) && (36 === requestNodeIndex))) {
            return this._NgModel_36_6.context;
        }
        if (((token === import24.NgControl) && (36 === requestNodeIndex))) {
            return this._NgControl_36_7;
        }
        if (((token === import25.NgControlStatus) && (36 === requestNodeIndex))) {
            return this._NgControlStatus_36_8.context;
        }
        if (((token === import20.NgClass) && ((44 <= requestNodeIndex) && (requestNodeIndex <= 45)))) {
            return this._NgClass_44_3.context;
        }
        if (((token === import20.NgClass) && ((46 <= requestNodeIndex) && (requestNodeIndex <= 47)))) {
            return this._NgClass_46_3.context;
        }
        if (((token === import20.NgClass) && ((48 <= requestNodeIndex) && (requestNodeIndex <= 49)))) {
            return this._NgClass_48_3.context;
        }
        if (((token === import20.NgClass) && ((50 <= requestNodeIndex) && (requestNodeIndex <= 51)))) {
            return this._NgClass_50_3.context;
        }
        if (((token === import20.NgClass) && (60 === requestNodeIndex))) {
            return this._NgClass_60_3.context;
        }
        if (((token === import21.DefaultValueAccessor) && (60 === requestNodeIndex))) {
            return this._DefaultValueAccessor_60_4.context;
        }
        if (((token === import22.NG_VALUE_ACCESSOR) && (60 === requestNodeIndex))) {
            return this._NG_VALUE_ACCESSOR_60_5;
        }
        if (((token === import23.NgModel) && (60 === requestNodeIndex))) {
            return this._NgModel_60_6.context;
        }
        if (((token === import24.NgControl) && (60 === requestNodeIndex))) {
            return this._NgControl_60_7;
        }
        if (((token === import25.NgControlStatus) && (60 === requestNodeIndex))) {
            return this._NgControlStatus_60_8.context;
        }
        if (((token === import20.NgClass) && ((68 <= requestNodeIndex) && (requestNodeIndex <= 69)))) {
            return this._NgClass_68_3.context;
        }
        if (((token === import20.NgClass) && ((70 <= requestNodeIndex) && (requestNodeIndex <= 71)))) {
            return this._NgClass_70_3.context;
        }
        if (((token === import20.NgClass) && ((72 <= requestNodeIndex) && (requestNodeIndex <= 73)))) {
            return this._NgClass_72_3.context;
        }
        if (((token === import20.NgClass) && ((74 <= requestNodeIndex) && (requestNodeIndex <= 75)))) {
            return this._NgClass_74_3.context;
        }
        if (((token === import21.DefaultValueAccessor) && (84 === requestNodeIndex))) {
            return this._DefaultValueAccessor_84_3.context;
        }
        if (((token === import22.NG_VALUE_ACCESSOR) && (84 === requestNodeIndex))) {
            return this._NG_VALUE_ACCESSOR_84_4;
        }
        if (((token === import23.NgModel) && (84 === requestNodeIndex))) {
            return this._NgModel_84_5.context;
        }
        if (((token === import24.NgControl) && (84 === requestNodeIndex))) {
            return this._NgControl_84_6;
        }
        if (((token === import25.NgControlStatus) && (84 === requestNodeIndex))) {
            return this._NgControlStatus_84_7.context;
        }
        if (((token === import20.NgClass) && ((94 <= requestNodeIndex) && (requestNodeIndex <= 95)))) {
            return this._NgClass_94_3.context;
        }
        if (((token === import20.NgClass) && ((97 <= requestNodeIndex) && (requestNodeIndex <= 98)))) {
            return this._NgClass_97_3.context;
        }
        if (((token === import21.DefaultValueAccessor) && (100 === requestNodeIndex))) {
            return this._DefaultValueAccessor_100_3.context;
        }
        if (((token === import26.RangeValueAccessor) && (100 === requestNodeIndex))) {
            return this._RangeValueAccessor_100_4.context;
        }
        if (((token === import22.NG_VALUE_ACCESSOR) && (100 === requestNodeIndex))) {
            return this._NG_VALUE_ACCESSOR_100_5;
        }
        if (((token === import23.NgModel) && (100 === requestNodeIndex))) {
            return this._NgModel_100_6.context;
        }
        if (((token === import24.NgControl) && (100 === requestNodeIndex))) {
            return this._NgControl_100_7;
        }
        if (((token === import25.NgControlStatus) && (100 === requestNodeIndex))) {
            return this._NgControlStatus_100_8.context;
        }
        if (((token === import21.DefaultValueAccessor) && (103 === requestNodeIndex))) {
            return this._DefaultValueAccessor_103_3.context;
        }
        if (((token === import22.NG_VALUE_ACCESSOR) && (103 === requestNodeIndex))) {
            return this._NG_VALUE_ACCESSOR_103_4;
        }
        if (((token === import23.NgModel) && (103 === requestNodeIndex))) {
            return this._NgModel_103_5.context;
        }
        if (((token === import24.NgControl) && (103 === requestNodeIndex))) {
            return this._NgControl_103_6;
        }
        if (((token === import25.NgControlStatus) && (103 === requestNodeIndex))) {
            return this._NgControlStatus_103_7.context;
        }
        if (((token === import20.NgClass) && ((1 <= requestNodeIndex) && (requestNodeIndex <= 105)))) {
            return this._NgClass_1_3.context;
        }
        return notFoundResult;
    }
    detectChangesInternal(throwOnChange) {
        const valUnwrapper = new import1.ValueUnwrapper();
        const currVal_1_0_0 = 'tone-entry tone-entry-row';
        this._NgClass_1_3.check_klass(currVal_1_0_0, throwOnChange, false);
        const currVal_1_0_1 = this._map_155(this.context.entry.temp);
        this._NgClass_1_3.check_ngClass(currVal_1_0_1, throwOnChange, false);
        this._NgClass_1_3.ngDoCheck(this, this._el_1, throwOnChange);
        const currVal_12_0_0 = 'form-control';
        this._NgClass_12_3.check_klass(currVal_12_0_0, throwOnChange, false);
        const currVal_12_0_1 = this._map_157(!this.context.validateInputNumber(this.context.entry.frequency));
        this._NgClass_12_3.check_ngClass(currVal_12_0_1, throwOnChange, false);
        this._NgClass_12_3.ngDoCheck(this, this._el_12, throwOnChange);
        this._DefaultValueAccessor_12_4.ngDoCheck(this, this._el_12, throwOnChange);
        const currVal_12_2_0 = this.context.entry.started;
        this._NgModel_12_6.check_isDisabled(currVal_12_2_0, throwOnChange, false);
        const currVal_12_2_1 = this.context.entry.frequency;
        this._NgModel_12_6.check_model(currVal_12_2_1, throwOnChange, false);
        this._NgModel_12_6.ngDoCheck(this, this._el_12, throwOnChange);
        this._NgControlStatus_12_8.ngDoCheck(this, this._el_12, throwOnChange);
        const currVal_20_0_0 = 'dropdown-item';
        this._NgClass_20_3.check_klass(currVal_20_0_0, throwOnChange, false);
        const currVal_20_0_1 = this._map_160((this.context.entry.oscillationType == 'sine'));
        this._NgClass_20_3.check_ngClass(currVal_20_0_1, throwOnChange, false);
        this._NgClass_20_3.ngDoCheck(this, this._el_20, throwOnChange);
        const currVal_22_0_0 = 'dropdown-item';
        this._NgClass_22_3.check_klass(currVal_22_0_0, throwOnChange, false);
        const currVal_22_0_1 = this._map_161((this.context.entry.oscillationType == 'square'));
        this._NgClass_22_3.check_ngClass(currVal_22_0_1, throwOnChange, false);
        this._NgClass_22_3.ngDoCheck(this, this._el_22, throwOnChange);
        const currVal_24_0_0 = 'dropdown-item';
        this._NgClass_24_3.check_klass(currVal_24_0_0, throwOnChange, false);
        const currVal_24_0_1 = this._map_162((this.context.entry.oscillationType == 'triangle'));
        this._NgClass_24_3.check_ngClass(currVal_24_0_1, throwOnChange, false);
        this._NgClass_24_3.ngDoCheck(this, this._el_24, throwOnChange);
        const currVal_26_0_0 = 'dropdown-item';
        this._NgClass_26_3.check_klass(currVal_26_0_0, throwOnChange, false);
        const currVal_26_0_1 = this._map_163((this.context.entry.oscillationType == 'sawtooth'));
        this._NgClass_26_3.check_ngClass(currVal_26_0_1, throwOnChange, false);
        this._NgClass_26_3.ngDoCheck(this, this._el_26, throwOnChange);
        const currVal_36_0_0 = 'form-control';
        this._NgClass_36_3.check_klass(currVal_36_0_0, throwOnChange, false);
        const currVal_36_0_1 = this._map_164((this.context.entry.delayAmount && !this.context.validateInputNumber(this.context.entry.delayAmount)));
        this._NgClass_36_3.check_ngClass(currVal_36_0_1, throwOnChange, false);
        this._NgClass_36_3.ngDoCheck(this, this._el_36, throwOnChange);
        this._DefaultValueAccessor_36_4.ngDoCheck(this, this._el_36, throwOnChange);
        const currVal_36_2_0 = this.context.entry.started;
        this._NgModel_36_6.check_isDisabled(currVal_36_2_0, throwOnChange, false);
        const currVal_36_2_1 = this.context.entry.delayAmount;
        this._NgModel_36_6.check_model(currVal_36_2_1, throwOnChange, false);
        this._NgModel_36_6.ngDoCheck(this, this._el_36, throwOnChange);
        this._NgControlStatus_36_8.ngDoCheck(this, this._el_36, throwOnChange);
        const currVal_44_0_0 = 'dropdown-item';
        this._NgClass_44_3.check_klass(currVal_44_0_0, throwOnChange, false);
        const currVal_44_0_1 = this._map_169((this.context.entry.delayUnit == this.context.TimeUnit.MILLISECONDS));
        this._NgClass_44_3.check_ngClass(currVal_44_0_1, throwOnChange, false);
        this._NgClass_44_3.ngDoCheck(this, this._el_44, throwOnChange);
        const currVal_46_0_0 = 'dropdown-item';
        this._NgClass_46_3.check_klass(currVal_46_0_0, throwOnChange, false);
        const currVal_46_0_1 = this._map_172((this.context.entry.delayUnit == this.context.TimeUnit.SECONDS));
        this._NgClass_46_3.check_ngClass(currVal_46_0_1, throwOnChange, false);
        this._NgClass_46_3.ngDoCheck(this, this._el_46, throwOnChange);
        const currVal_48_0_0 = 'dropdown-item';
        this._NgClass_48_3.check_klass(currVal_48_0_0, throwOnChange, false);
        const currVal_48_0_1 = this._map_175((this.context.entry.delayUnit == this.context.TimeUnit.MINUTES));
        this._NgClass_48_3.check_ngClass(currVal_48_0_1, throwOnChange, false);
        this._NgClass_48_3.ngDoCheck(this, this._el_48, throwOnChange);
        const currVal_50_0_0 = 'dropdown-item';
        this._NgClass_50_3.check_klass(currVal_50_0_0, throwOnChange, false);
        const currVal_50_0_1 = this._map_178((this.context.entry.delayUnit == this.context.TimeUnit.HOURS));
        this._NgClass_50_3.check_ngClass(currVal_50_0_1, throwOnChange, false);
        this._NgClass_50_3.ngDoCheck(this, this._el_50, throwOnChange);
        const currVal_60_0_0 = 'form-control';
        this._NgClass_60_3.check_klass(currVal_60_0_0, throwOnChange, false);
        const currVal_60_0_1 = this._map_181((this.context.entry.durationAmount && !this.context.validateInputNumber(this.context.entry.durationAmount)));
        this._NgClass_60_3.check_ngClass(currVal_60_0_1, throwOnChange, false);
        this._NgClass_60_3.ngDoCheck(this, this._el_60, throwOnChange);
        this._DefaultValueAccessor_60_4.ngDoCheck(this, this._el_60, throwOnChange);
        const currVal_60_2_0 = this.context.entry.started;
        this._NgModel_60_6.check_isDisabled(currVal_60_2_0, throwOnChange, false);
        const currVal_60_2_1 = this.context.entry.durationAmount;
        this._NgModel_60_6.check_model(currVal_60_2_1, throwOnChange, false);
        this._NgModel_60_6.ngDoCheck(this, this._el_60, throwOnChange);
        this._NgControlStatus_60_8.ngDoCheck(this, this._el_60, throwOnChange);
        const currVal_68_0_0 = 'dropdown-item';
        this._NgClass_68_3.check_klass(currVal_68_0_0, throwOnChange, false);
        const currVal_68_0_1 = this._map_185((this.context.entry.durationUnit == this.context.TimeUnit.MILLISECONDS));
        this._NgClass_68_3.check_ngClass(currVal_68_0_1, throwOnChange, false);
        this._NgClass_68_3.ngDoCheck(this, this._el_68, throwOnChange);
        const currVal_70_0_0 = 'dropdown-item';
        this._NgClass_70_3.check_klass(currVal_70_0_0, throwOnChange, false);
        const currVal_70_0_1 = this._map_188((this.context.entry.durationUnit == this.context.TimeUnit.SECONDS));
        this._NgClass_70_3.check_ngClass(currVal_70_0_1, throwOnChange, false);
        this._NgClass_70_3.ngDoCheck(this, this._el_70, throwOnChange);
        const currVal_72_0_0 = 'dropdown-item';
        this._NgClass_72_3.check_klass(currVal_72_0_0, throwOnChange, false);
        const currVal_72_0_1 = this._map_191((this.context.entry.durationUnit == this.context.TimeUnit.MINUTES));
        this._NgClass_72_3.check_ngClass(currVal_72_0_1, throwOnChange, false);
        this._NgClass_72_3.ngDoCheck(this, this._el_72, throwOnChange);
        const currVal_74_0_0 = 'dropdown-item';
        this._NgClass_74_3.check_klass(currVal_74_0_0, throwOnChange, false);
        const currVal_74_0_1 = this._map_194((this.context.entry.durationUnit == this.context.TimeUnit.HOURS));
        this._NgClass_74_3.check_ngClass(currVal_74_0_1, throwOnChange, false);
        this._NgClass_74_3.ngDoCheck(this, this._el_74, throwOnChange);
        this._DefaultValueAccessor_84_3.ngDoCheck(this, this._el_84, throwOnChange);
        const currVal_84_1_0 = this.context.entry.started;
        this._NgModel_84_5.check_isDisabled(currVal_84_1_0, throwOnChange, false);
        const currVal_84_1_1 = this.context.entry.volume;
        this._NgModel_84_5.check_model(currVal_84_1_1, throwOnChange, false);
        this._NgModel_84_5.ngDoCheck(this, this._el_84, throwOnChange);
        this._NgControlStatus_84_7.ngDoCheck(this, this._el_84, throwOnChange);
        const currVal_94_0_0 = 'left-desc';
        this._NgClass_94_3.check_klass(currVal_94_0_0, throwOnChange, false);
        const currVal_94_0_1 = this._map_197(this.context.entry.started);
        this._NgClass_94_3.check_ngClass(currVal_94_0_1, throwOnChange, false);
        this._NgClass_94_3.ngDoCheck(this, this._el_94, throwOnChange);
        const currVal_97_0_0 = 'right-desc';
        this._NgClass_97_3.check_klass(currVal_97_0_0, throwOnChange, false);
        const currVal_97_0_1 = this._map_198(this.context.entry.started);
        this._NgClass_97_3.check_ngClass(currVal_97_0_1, throwOnChange, false);
        this._NgClass_97_3.ngDoCheck(this, this._el_97, throwOnChange);
        this._DefaultValueAccessor_100_3.ngDoCheck(this, this._el_100, throwOnChange);
        this._RangeValueAccessor_100_4.ngDoCheck(this, this._el_100, throwOnChange);
        const currVal_100_2_0 = this.context.entry.started;
        this._NgModel_100_6.check_isDisabled(currVal_100_2_0, throwOnChange, false);
        const currVal_100_2_1 = this.context.entry.pan;
        this._NgModel_100_6.check_model(currVal_100_2_1, throwOnChange, false);
        this._NgModel_100_6.ngDoCheck(this, this._el_100, throwOnChange);
        this._NgControlStatus_100_8.ngDoCheck(this, this._el_100, throwOnChange);
        this._DefaultValueAccessor_103_3.ngDoCheck(this, this._el_103, throwOnChange);
        const currVal_103_1_0 = this.context.entry.started;
        this._NgModel_103_5.check_isDisabled(currVal_103_1_0, throwOnChange, false);
        const currVal_103_1_1 = this.context.entry.pan;
        this._NgModel_103_5.check_model(currVal_103_1_1, throwOnChange, false);
        this._NgModel_103_5.ngDoCheck(this, this._el_103, throwOnChange);
        this._NgControlStatus_103_7.ngDoCheck(this, this._el_103, throwOnChange);
        const currVal_156 = (this.context.entry.started || this.context.entry.temp);
        if (import3.checkBinding(throwOnChange, this._expr_156, currVal_156)) {
            this.renderer.setElementProperty(this._el_5, 'hidden', currVal_156);
            this._expr_156 = currVal_156;
        }
        this._NgControlStatus_12_8.checkHost(this, this, this._el_12, throwOnChange);
        const currVal_158 = this.context.entry.started;
        if (import3.checkBinding(throwOnChange, this._expr_158, currVal_158)) {
            this.renderer.setElementProperty(this._el_16, 'disabled', currVal_158);
            this._expr_158 = currVal_158;
        }
        const currVal_159 = import3.inlineInterpolate(1, '', this.context.entry.oscillationType, '');
        if (import3.checkBinding(throwOnChange, this._expr_159, currVal_159)) {
            this.renderer.setText(this._text_17, currVal_159);
            this._expr_159 = currVal_159;
        }
        this._NgControlStatus_36_8.checkHost(this, this, this._el_36, throwOnChange);
        const currVal_165 = this.context.entry.started;
        if (import3.checkBinding(throwOnChange, this._expr_165, currVal_165)) {
            this.renderer.setElementProperty(this._el_40, 'disabled', currVal_165);
            this._expr_165 = currVal_165;
        }
        valUnwrapper.reset();
        const currVal_166 = import3.inlineInterpolate(1, '', valUnwrapper.unwrap(import3.castByValue(this._pipe_timeunit_0_0, this._pipe_timeunit_0.transform)(this.context.entry.delayUnit, 'shortname')), '');
        if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange, this._expr_166, currVal_166))) {
            this.renderer.setText(this._text_41, currVal_166);
            this._expr_166 = currVal_166;
        }
        valUnwrapper.reset();
        const currVal_170 = import3.inlineInterpolate(1, '', valUnwrapper.unwrap(import3.castByValue(this._pipe_timeunit_0_1, this._pipe_timeunit_0.transform)(this.context.TimeUnit.MILLISECONDS, 'shortname')), '');
        if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange, this._expr_170, currVal_170))) {
            this.renderer.setText(this._text_45, currVal_170);
            this._expr_170 = currVal_170;
        }
        valUnwrapper.reset();
        const currVal_173 = import3.inlineInterpolate(1, '', valUnwrapper.unwrap(import3.castByValue(this._pipe_timeunit_0_2, this._pipe_timeunit_0.transform)(this.context.TimeUnit.SECONDS, 'shortname')), '');
        if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange, this._expr_173, currVal_173))) {
            this.renderer.setText(this._text_47, currVal_173);
            this._expr_173 = currVal_173;
        }
        valUnwrapper.reset();
        const currVal_176 = import3.inlineInterpolate(1, '', valUnwrapper.unwrap(import3.castByValue(this._pipe_timeunit_0_3, this._pipe_timeunit_0.transform)(this.context.TimeUnit.MINUTES, 'shortname')), '');
        if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange, this._expr_176, currVal_176))) {
            this.renderer.setText(this._text_49, currVal_176);
            this._expr_176 = currVal_176;
        }
        valUnwrapper.reset();
        const currVal_179 = import3.inlineInterpolate(1, '', valUnwrapper.unwrap(import3.castByValue(this._pipe_timeunit_0_4, this._pipe_timeunit_0.transform)(this.context.TimeUnit.HOURS, 'shortname')), '');
        if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange, this._expr_179, currVal_179))) {
            this.renderer.setText(this._text_51, currVal_179);
            this._expr_179 = currVal_179;
        }
        this._NgControlStatus_60_8.checkHost(this, this, this._el_60, throwOnChange);
        const currVal_182 = this.context.entry.started;
        if (import3.checkBinding(throwOnChange, this._expr_182, currVal_182)) {
            this.renderer.setElementProperty(this._el_64, 'disabled', currVal_182);
            this._expr_182 = currVal_182;
        }
        valUnwrapper.reset();
        const currVal_183 = import3.inlineInterpolate(1, '', valUnwrapper.unwrap(import3.castByValue(this._pipe_timeunit_0_5, this._pipe_timeunit_0.transform)(this.context.entry.durationUnit, 'shortname')), '');
        if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange, this._expr_183, currVal_183))) {
            this.renderer.setText(this._text_65, currVal_183);
            this._expr_183 = currVal_183;
        }
        valUnwrapper.reset();
        const currVal_186 = import3.inlineInterpolate(1, '', valUnwrapper.unwrap(import3.castByValue(this._pipe_timeunit_0_6, this._pipe_timeunit_0.transform)(this.context.TimeUnit.MILLISECONDS, 'shortname')), '');
        if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange, this._expr_186, currVal_186))) {
            this.renderer.setText(this._text_69, currVal_186);
            this._expr_186 = currVal_186;
        }
        valUnwrapper.reset();
        const currVal_189 = import3.inlineInterpolate(1, '', valUnwrapper.unwrap(import3.castByValue(this._pipe_timeunit_0_7, this._pipe_timeunit_0.transform)(this.context.TimeUnit.SECONDS, 'shortname')), '');
        if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange, this._expr_189, currVal_189))) {
            this.renderer.setText(this._text_71, currVal_189);
            this._expr_189 = currVal_189;
        }
        valUnwrapper.reset();
        const currVal_192 = import3.inlineInterpolate(1, '', valUnwrapper.unwrap(import3.castByValue(this._pipe_timeunit_0_8, this._pipe_timeunit_0.transform)(this.context.TimeUnit.MINUTES, 'shortname')), '');
        if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange, this._expr_192, currVal_192))) {
            this.renderer.setText(this._text_73, currVal_192);
            this._expr_192 = currVal_192;
        }
        valUnwrapper.reset();
        const currVal_195 = import3.inlineInterpolate(1, '', valUnwrapper.unwrap(import3.castByValue(this._pipe_timeunit_0_9, this._pipe_timeunit_0.transform)(this.context.TimeUnit.HOURS, 'shortname')), '');
        if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange, this._expr_195, currVal_195))) {
            this.renderer.setText(this._text_75, currVal_195);
            this._expr_195 = currVal_195;
        }
        this._NgControlStatus_84_7.checkHost(this, this, this._el_84, throwOnChange);
        this._NgControlStatus_100_8.checkHost(this, this, this._el_100, throwOnChange);
        this._NgControlStatus_103_7.checkHost(this, this, this._el_103, throwOnChange);
    }
    destroyInternal() {
        this._NgModel_12_6.ngOnDestroy();
        this._NgModel_36_6.ngOnDestroy();
        this._NgModel_60_6.ngOnDestroy();
        this._NgModel_84_5.ngOnDestroy();
        this._NgModel_100_6.ngOnDestroy();
        this._NgModel_103_5.ngOnDestroy();
    }
    handleEvent_5(eventName, $event) {
        this.markPathToRootAsCheckOnce();
        var result = true;
        if ((eventName == 'click')) {
            const pd_sub_0 = (this.context.clickRemove() !== false);
            result = (pd_sub_0 && result);
        }
        return result;
    }
    handleEvent_12(eventName, $event) {
        this.markPathToRootAsCheckOnce();
        var result = true;
        result = (this._DefaultValueAccessor_12_4.handleEvent(eventName, $event) && result);
        if ((eventName == 'ngModelChange')) {
            const pd_sub_0 = ((this.context.entry.frequency = $event) !== false);
            result = (pd_sub_0 && result);
        }
        if ((eventName == 'ngModelChange')) {
            const pd_sub_1 = (this.context.addEntryIfTemp(this.context.entry) !== false);
            result = (pd_sub_1 && result);
        }
        return result;
    }
    handleEvent_20(eventName, $event) {
        this.markPathToRootAsCheckOnce();
        var result = true;
        if ((eventName == 'click')) {
            const pd_sub_0 = ((this.context.entry.oscillationType = 'sine') !== false);
            result = (pd_sub_0 && result);
        }
        return result;
    }
    handleEvent_22(eventName, $event) {
        this.markPathToRootAsCheckOnce();
        var result = true;
        if ((eventName == 'click')) {
            const pd_sub_0 = ((this.context.entry.oscillationType = 'square') !== false);
            result = (pd_sub_0 && result);
        }
        return result;
    }
    handleEvent_24(eventName, $event) {
        this.markPathToRootAsCheckOnce();
        var result = true;
        if ((eventName == 'click')) {
            const pd_sub_0 = ((this.context.entry.oscillationType = 'triangle') !== false);
            result = (pd_sub_0 && result);
        }
        return result;
    }
    handleEvent_26(eventName, $event) {
        this.markPathToRootAsCheckOnce();
        var result = true;
        if ((eventName == 'click')) {
            const pd_sub_0 = ((this.context.entry.oscillationType = 'sawtooth') !== false);
            result = (pd_sub_0 && result);
        }
        return result;
    }
    handleEvent_36(eventName, $event) {
        this.markPathToRootAsCheckOnce();
        var result = true;
        result = (this._DefaultValueAccessor_36_4.handleEvent(eventName, $event) && result);
        if ((eventName == 'ngModelChange')) {
            const pd_sub_0 = ((this.context.entry.delayAmount = $event) !== false);
            result = (pd_sub_0 && result);
        }
        return result;
    }
    handleEvent_44(eventName, $event) {
        this.markPathToRootAsCheckOnce();
        var result = true;
        if ((eventName == 'click')) {
            const pd_sub_0 = ((this.context.entry.delayUnit = this.context.TimeUnit.MILLISECONDS) !== false);
            result = (pd_sub_0 && result);
        }
        return result;
    }
    handleEvent_46(eventName, $event) {
        this.markPathToRootAsCheckOnce();
        var result = true;
        if ((eventName == 'click')) {
            const pd_sub_0 = ((this.context.entry.delayUnit = this.context.TimeUnit.SECONDS) !== false);
            result = (pd_sub_0 && result);
        }
        return result;
    }
    handleEvent_48(eventName, $event) {
        this.markPathToRootAsCheckOnce();
        var result = true;
        if ((eventName == 'click')) {
            const pd_sub_0 = ((this.context.entry.delayUnit = this.context.TimeUnit.MINUTES) !== false);
            result = (pd_sub_0 && result);
        }
        return result;
    }
    handleEvent_50(eventName, $event) {
        this.markPathToRootAsCheckOnce();
        var result = true;
        if ((eventName == 'click')) {
            const pd_sub_0 = ((this.context.entry.delayUnit = this.context.TimeUnit.HOURS) !== false);
            result = (pd_sub_0 && result);
        }
        return result;
    }
    handleEvent_60(eventName, $event) {
        this.markPathToRootAsCheckOnce();
        var result = true;
        result = (this._DefaultValueAccessor_60_4.handleEvent(eventName, $event) && result);
        if ((eventName == 'ngModelChange')) {
            const pd_sub_0 = ((this.context.entry.durationAmount = $event) !== false);
            result = (pd_sub_0 && result);
        }
        return result;
    }
    handleEvent_68(eventName, $event) {
        this.markPathToRootAsCheckOnce();
        var result = true;
        if ((eventName == 'click')) {
            const pd_sub_0 = ((this.context.entry.durationUnit = this.context.TimeUnit.MILLISECONDS) !== false);
            result = (pd_sub_0 && result);
        }
        return result;
    }
    handleEvent_70(eventName, $event) {
        this.markPathToRootAsCheckOnce();
        var result = true;
        if ((eventName == 'click')) {
            const pd_sub_0 = ((this.context.entry.durationUnit = this.context.TimeUnit.SECONDS) !== false);
            result = (pd_sub_0 && result);
        }
        return result;
    }
    handleEvent_72(eventName, $event) {
        this.markPathToRootAsCheckOnce();
        var result = true;
        if ((eventName == 'click')) {
            const pd_sub_0 = ((this.context.entry.durationUnit = this.context.TimeUnit.MINUTES) !== false);
            result = (pd_sub_0 && result);
        }
        return result;
    }
    handleEvent_74(eventName, $event) {
        this.markPathToRootAsCheckOnce();
        var result = true;
        if ((eventName == 'click')) {
            const pd_sub_0 = ((this.context.entry.durationUnit = this.context.TimeUnit.HOURS) !== false);
            result = (pd_sub_0 && result);
        }
        return result;
    }
    handleEvent_84(eventName, $event) {
        this.markPathToRootAsCheckOnce();
        var result = true;
        result = (this._DefaultValueAccessor_84_3.handleEvent(eventName, $event) && result);
        if ((eventName == 'ngModelChange')) {
            const pd_sub_0 = ((this.context.entry.volume = $event) !== false);
            result = (pd_sub_0 && result);
        }
        if ((eventName == 'change')) {
            const pd_sub_1 = ((this.context.entry.volume = (this.context.MathUtil.clamp(this.context.entry.volume, 0, 100) || 100)) !== false);
            result = (pd_sub_1 && result);
        }
        return result;
    }
    handleEvent_100(eventName, $event) {
        this.markPathToRootAsCheckOnce();
        var result = true;
        result = (this._DefaultValueAccessor_100_3.handleEvent(eventName, $event) && result);
        result = (this._RangeValueAccessor_100_4.handleEvent(eventName, $event) && result);
        if ((eventName == 'ngModelChange')) {
            const pd_sub_0 = ((this.context.entry.pan = $event) !== false);
            result = (pd_sub_0 && result);
        }
        return result;
    }
    handleEvent_103(eventName, $event) {
        this.markPathToRootAsCheckOnce();
        var result = true;
        result = (this._DefaultValueAccessor_103_3.handleEvent(eventName, $event) && result);
        if ((eventName == 'ngModelChange')) {
            const pd_sub_0 = ((this.context.entry.pan = $event) !== false);
            result = (pd_sub_0 && result);
        }
        if ((eventName == 'change')) {
            const pd_sub_1 = ((this.context.entry.pan = (this.context.MathUtil.clamp(this.context.entry.pan, (0 - 1), 1) || 0)) !== false);
            result = (pd_sub_1 && result);
        }
        return result;
    }
}
//# sourceMappingURL=tone-entry.component.ngfactory.js.map